/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomSigningRoles } from './CustomSigningRoles';
import {
    CustomSigningRolesFromJSON,
    CustomSigningRolesFromJSONTyped,
    CustomSigningRolesToJSON,
} from './CustomSigningRoles';
import type { IAPCOMMSCHANNEL } from './IAPCOMMSCHANNEL';
import {
    IAPCOMMSCHANNELFromJSON,
    IAPCOMMSCHANNELFromJSONTyped,
    IAPCOMMSCHANNELToJSON,
} from './IAPCOMMSCHANNEL';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPSIGNATORYROLE } from './IAPSIGNATORYROLE';
import {
    IAPSIGNATORYROLEFromJSON,
    IAPSIGNATORYROLEFromJSONTyped,
    IAPSIGNATORYROLEToJSON,
} from './IAPSIGNATORYROLE';

/**
 * 
 * @export
 * @interface SignatoryViewModel
 */
export interface SignatoryViewModel {
    /**
     * 
     * @type {number}
     * @memberof SignatoryViewModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    contactNumber?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof SignatoryViewModel
     */
    countryCodeId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    countryDialingCode?: string;
    /**
     * 
     * @type {IAPCOMMSCHANNEL}
     * @memberof SignatoryViewModel
     */
    preferredCommunicationMethod?: IAPCOMMSCHANNEL;
    /**
     * 
     * @type {string}
     * @memberof SignatoryViewModel
     */
    uuid?: string;
    /**
     * 
     * @type {Array<IAPSIGNATORYROLE>}
     * @memberof SignatoryViewModel
     */
    roles: Array<IAPSIGNATORYROLE>;
    /**
     * 
     * @type {number}
     * @memberof SignatoryViewModel
     */
    linkedPartyId?: number;
    /**
     * 
     * @type {Array<CustomSigningRoles>}
     * @memberof SignatoryViewModel
     */
    customRoles: Array<CustomSigningRoles>;
}

/**
 * Check if a given object implements the SignatoryViewModel interface.
 */
export function instanceOfSignatoryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "roles" in value;
    isInstance = isInstance && "customRoles" in value;

    return isInstance;
}

export function SignatoryViewModelFromJSON(json: any): SignatoryViewModel {
    return SignatoryViewModelFromJSONTyped(json, false);
}

export function SignatoryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatoryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'contactNumber': !exists(json, 'ContactNumber') ? undefined : json['ContactNumber'],
        'countryCodeId': !exists(json, 'CountryCodeId') ? undefined : IAPCOUNTRYFromJSON(json['CountryCodeId']),
        'countryDialingCode': !exists(json, 'CountryDialingCode') ? undefined : json['CountryDialingCode'],
        'preferredCommunicationMethod': !exists(json, 'PreferredCommunicationMethod') ? undefined : IAPCOMMSCHANNELFromJSON(json['PreferredCommunicationMethod']),
        'uuid': !exists(json, 'Uuid') ? undefined : json['Uuid'],
        'roles': ((json['Roles'] as Array<any>).map(IAPSIGNATORYROLEFromJSON)),
        'linkedPartyId': !exists(json, 'LinkedPartyId') ? undefined : json['LinkedPartyId'],
        'customRoles': ((json['CustomRoles'] as Array<any>).map(CustomSigningRolesFromJSON)),
    };
}

export function SignatoryViewModelToJSON(value?: SignatoryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'Email': value.email,
        'ContactNumber': value.contactNumber,
        'CountryCodeId': IAPCOUNTRYToJSON(value.countryCodeId),
        'CountryDialingCode': value.countryDialingCode,
        'PreferredCommunicationMethod': IAPCOMMSCHANNELToJSON(value.preferredCommunicationMethod),
        'Uuid': value.uuid,
        'Roles': ((value.roles as Array<any>).map(IAPSIGNATORYROLEToJSON)),
        'LinkedPartyId': value.linkedPartyId,
        'CustomRoles': ((value.customRoles as Array<any>).map(CustomSigningRolesToJSON)),
    };
}

